import { cacheKeys } from "config";
import { useQuery } from "react-query";
import { PaginationApiParams } from "@coolset/cs-ui";
import { tagsClient } from "../client/tagsClient";

export const useTagsData = (getAllParams?: PaginationApiParams, id?: number | string | null) => {
  const { data: { data: tagsData } = {}, isLoading: isLoadingTags } = useQuery(
    [cacheKeys.tags.getTags, getAllParams],
    () => tagsClient.getTags(getAllParams)
  );

  const { data: tagData, isLoading: isLoadingTag } = useQuery(
    [cacheKeys.tags.getTag, id],
    () => {
      if (!id) {
        return;
      }
      return tagsClient.getTag(id);
    }
  );

  return {
    tags: tagsData?.results || [],
    tagsCount: tagsData?.count || 0,
    tag: tagData?.data,
    isLoadingTags,
    isLoadingTag,
  };
};
